var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriptionHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 463,
    viewBox: "0 0 1440 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15937_39237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-91.1039 -2.76953H1509.96C1509.96 -2.76953 1970.23 278.751 1509.96 379.671C1049.69 480.591 309.162 475.281 -91.1039 379.671C-491.37 284.061 -91.1039 -2.76953 -91.1039 -2.76953Z",
    fill: "url(#paint0_linear_15937_39237)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 -25.9688C1523.44 -25.9688 1283.83 227.954 1075.73 280.154",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 -12.6328C1523.44 -12.6328 1286.73 140.094 1075.73 161.233",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 0.796875C1523.44 0.796875 1289.64 150.959 1075.73 161.229",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 57.2734C1523.44 57.2734 1292.59 204.884 1075.73 204.321",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 79.0977C1523.44 79.0977 1295.44 224.157 1075.73 212.762",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 99.8047C1523.44 99.8047 1298.34 242.299 1075.73 220.085",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 119.781C1523.44 119.781 1301.23 259.724 1075.73 226.677",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 139.277C1523.44 139.277 1304.13 276.669 1075.73 232.79",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 158.426C1523.44 158.426 1307.05 293.253 1075.73 238.554",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 177.355C1523.44 177.355 1309.94 309.618 1075.73 244.087",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 196.102C1523.44 196.102 1312.84 325.813 1075.73 249.45",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 214.727C1523.44 214.727 1315.74 341.886 1075.73 254.691",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 253.574C1523.44 253.574 1318.63 378.17 1075.73 280.154",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 266.957C1523.44 266.957 1321.53 388.976 1075.73 280.153",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 280.34C1523.44 280.34 1324.43 399.832 1075.73 280.152",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 293.724C1523.44 293.724 1327.34 410.652 1075.73 280.152",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 307.108C1523.44 307.108 1330.24 421.496 1075.73 280.152",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2322C281.141 88.2322 167.528 -123.559 -77.5728 -13.0851",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2324C281.141 88.2324 251.521 39.2623 190.931 3.87628C131.391 -30.9594 41.2312 -53.5619 -77.5728 -5.84268",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2291C281.141 88.2291 250.771 44.0872 189.605 12.5537C129.565 -18.5294 38.4919 -39.2557 -77.5728 1.39632",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2307C281.141 88.2307 250.02 48.9296 188.279 21.2237C127.764 -6.09451 35.6776 -24.9571 -77.5728 8.71534",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.232C281.141 88.232 249.269 53.7591 186.903 29.8932C125.9 6.32754 32.938 -10.6588 -77.623 15.8839",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2299C281.141 88.2299 248.519 58.6603 185.652 38.647C124.136 18.7713 30.2489 3.62368 -77.5728 23.1367",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.232C281.141 88.232 247.731 63.5656 184.301 47.2672C122.285 31.3316 27.4971 17.9727 -77.5728 30.381",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.234C281.141 88.234 246.943 68.4083 182.976 55.9375C120.434 43.7794 24.7453 32.2843 -77.5728 37.6253",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2312C281.141 88.2312 246.243 73.2212 181.65 64.6155C118.67 56.1598 22.006 46.591 -77.5728 44.9023",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2334C281.141 88.2334 245.505 78.0766 180.324 73.2985C116.857 68.6704 19.2917 60.9027 -77.5728 52.1094",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2333C281.141 88.2333 244.754 82.9047 178.998 81.9791C115.055 81.066 16.5023 75.2121 -77.5728 59.3516",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2331C281.141 88.2331 244.004 87.6077 177.672 90.6473C113.242 93.3741 13.813 89.509 -77.5728 66.5938",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2291C281.141 88.2291 243.19 92.4319 176.346 99.324C111.428 105.803 11.0111 103.814 -77.5728 73.832",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2329C281.141 88.2329 242.503 97.2764 175.02 108.009C109.614 118.24 8.25932 118.128 -77.5728 81.0781",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2344C281.141 88.2344 241.752 102.119 173.694 116.691C107.8 130.675 5.53251 132.464 -77.5728 88.3219",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2344C281.141 88.2344 241.001 106.997 172.318 125.372C105.936 143.108 2.71789 146.748 -77.623 95.5768",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.141 88.2344C281.141 88.2344 240.251 111.788 171.067 134.04C104.198 155.542 0.0412461 161.058 -77.5479 102.769",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 122.855C1523.44 122.855 1332.73 61.8522 913.854 187.085C690.009 254.005 581.09 178.567 473.394 178.73C311.161 178.968 222.208 275.895 -77.5479 165.821",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 134.704C1523.44 134.704 1320.86 57.7276 905.738 180.297C673.48 248.192 574.259 186.989 461.717 186.551C297.962 186.251 203.415 272.008 -77.5356 168.814",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 146.117C1523.44 146.117 1309.74 54.1059 897.68 173.072C657.442 242.456 567.508 194.812 449.978 194.061C284.732 193.011 184.722 267.861 -77.5664 171.546",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 156.835C1523.44 156.835 1298.1 49.1254 889.61 165.165C641.155 235.737 560.742 202.052 438.274 200.826C271.513 199.163 165.974 262.88 -77.5728 173.446",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 167.191C1523.44 167.191 1286.49 43.7466 881.541 156.884C624.803 228.607 553.973 208.919 426.576 207.218C258.299 204.966 147.253 257.576 -77.5728 175.021",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 177.257C1523.44 177.257 1274.62 38.0021 873.451 148.313C608.43 221.161 547.185 215.52 414.877 213.356C245.107 210.529 128.514 252.007 -77.5728 176.332",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 187.122C1523.44 187.122 1262.88 32.019 865.379 139.591C592.033 213.54 540.413 221.97 403.177 219.269C231.893 215.891 109.788 246.224 -77.5728 177.428",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 197.209C1523.44 197.209 1251.03 26.1706 857.313 131.053C575.534 206.103 533.651 228.618 391.482 225.403C218.699 221.488 91.0456 240.651 -77.5728 178.735",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 208.398C1523.44 208.398 1239.14 21.3234 849.244 123.554C559.161 199.567 526.904 236.329 379.806 232.576C205.487 228.123 72.3032 236.129 -77.5728 181.092",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 219.444C1523.44 219.444 1227.21 16.3967 841.174 115.975C542.66 192.964 520.117 243.961 368.11 239.67C192.297 234.667 53.5857 231.515 -77.5703 183.383",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 179.854C1523.44 179.854 1215.24 -39.2794 833.108 57.7476C526.161 135.674 513.331 200.955 356.416 196.115C179.08 190.649 34.8395 176.239 -77.5728 134.961",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 190.696C1523.44 190.696 1203.24 -44.5609 825.015 49.9019C509.594 128.704 506.563 208.345 344.711 202.941C165.867 196.975 16.117 171.383 -77.5703 136.985",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 315.011C1523.44 315.011 1191.22 -95.238 816.861 54.9619C493.029 184.956 499.732 338.36 333.013 328.624C152.655 318.093 -2.62416 258.042 -77.5728 213.137",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 328.533C1523.44 328.533 1179.16 -97.4054 808.877 45.2307C476.421 173.295 492.944 346.228 321.315 335.5C139.418 324.77 -21.3666 248.028 -77.5728 215.28",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 341.74C1523.44 341.74 1167.1 -99.8765 800.723 35.8288C459.685 162.174 486.112 353.708 309.531 342.383C126.161 331.076 -40.0878 238.686 -77.5728 217.282",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 352.98C1523.44 352.98 1154.78 -102.531 792.739 26.6444C442.885 150.312 479.431 359.446 297.918 347.608C113.013 335.781 -58.8303 228.815 -77.5728 218.386",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 363.821C1523.44 363.821 1142.91 -104.609 784.669 17.5906C426.426 139.791 472.664 365.062 286.22 352.712C99.7764 340.363 -77.5728 219.404 -77.5728 219.404",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 125.154C-77.623 125.154 113.093 64.1505 531.965 189.371C755.81 256.291 864.724 180.866 972.42 181.028C1134.65 181.266 1223.61 278.18 1523.37 168.107",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 137.034C-77.623 137.034 124.962 60.0579 540.08 182.614C772.338 250.522 871.559 189.319 984.103 188.944C1147.86 188.643 1242.4 274.4 1523.36 171.207",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 148.441C-77.623 148.441 136.08 56.38 548.139 175.459C788.377 244.843 878.311 197.199 995.847 196.448C1161.09 195.397 1261.1 270.247 1523.39 173.933",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 159.151C-77.623 159.151 147.714 51.504 556.208 167.481C804.664 238.053 885.078 204.368 1007.55 203.142C1174.31 201.479 1279.85 265.196 1523.39 175.762",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 169.496C-77.623 169.496 159.327 46.0513 564.278 159.189C821.016 230.912 891.845 211.224 1019.24 209.522C1187.52 207.271 1298.57 259.893 1523.39 177.339",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 179.558C-77.623 179.558 171.196 40.3029 572.368 150.614C837.389 223.462 898.634 217.821 1030.94 215.657C1200.71 212.83 1317.31 254.308 1523.39 178.632",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 189.427C-77.623 189.427 182.936 34.3237 580.44 141.895C853.786 215.844 905.406 224.275 1042.64 221.573C1213.93 218.196 1336.03 248.529 1523.39 179.733",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 199.477C-77.623 199.477 194.784 28.4504 588.506 133.27C870.285 208.32 912.168 230.835 1054.34 227.62C1227.12 223.705 1354.77 242.868 1523.39 180.952",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 210.71C-77.623 210.71 206.675 23.6855 596.575 125.866C886.658 201.879 918.915 238.641 1066.01 234.888C1240.33 230.436 1373.51 238.441 1523.39 183.404",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 221.745C-77.623 221.745 218.608 18.6975 604.644 118.276C903.159 195.265 925.702 246.261 1077.71 241.971C1253.52 236.968 1392.23 233.816 1523.39 185.684",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 182.155C-77.623 182.155 230.582 -36.9786 612.711 60.0484C919.658 137.975 932.487 203.256 1089.4 198.415C1266.73 192.937 1410.97 178.565 1523.38 137.287",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 192.999C-77.623 192.999 242.58 -42.2578 620.804 52.255C936.225 131.057 939.253 210.698 1101.11 205.294C1279.95 199.328 1429.7 173.736 1523.39 139.338",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 317.313C-77.623 317.313 254.598 -92.9406 628.958 57.2643C952.791 187.258 946.088 340.663 1112.81 330.926C1293.17 320.394 1448.44 260.347 1523.39 215.444",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 330.835C-77.623 330.835 266.66 -95.1031 636.942 47.5305C969.398 175.597 952.876 348.533 1124.5 337.802C1306.4 327.093 1467.18 250.329 1523.39 217.482",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 344.043C-77.623 344.043 278.713 -97.5683 645.08 38.132C986.111 164.481 959.684 356.011 1136.26 344.686C1319.67 333.381 1485.96 240.992 1523.44 219.585",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 355.278C-77.623 355.278 291.037 -100.275 653.08 28.9989C1002.94 152.676 966.389 361.82 1147.9 349.987C1332.81 338.154 1504.65 231.183 1523.39 220.754",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.623 366.116C-77.623 366.116 302.91 -102.308 661.157 19.8857C1019.4 142.08 973.167 367.367 1159.57 355.014C1345.97 342.66 1523.37 221.705 1523.37 221.705",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1523.44 383.225C1523.44 383.225 1253.96 -10.8081 933.266 -22.7436C588.663 -35.5646 480.712 257.109 287.245 306.798C68.8496 362.889 -77.5728 304.535 -77.5728 304.535",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15937_39237",
    x: -275,
    y: -5.76953,
    width: 1995.52,
    height: 468.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15937_39237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15937_39237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15937_39237",
    x1: 936.983,
    y1: 898.132,
    x2: 936.458,
    y2: -42.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#044E97"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionHeroImage);
export default __webpack_public_path__ + "static/media/SubscriptionHeroImage.a70a64f5fa0530384485813e56345538.svg";
export { ForwardRef as ReactComponent };